import { useRef, type ReactNode } from 'react';
import { TourControls } from './TourControls';
import { MarzipanoControllerContext } from '../context/MarzipanoControllerContext';
import { useMarzipano } from '../hooks/useMarzipano';
import styles from './MarzipanoViewer.module.css';

interface MarzipanoViewerProps {
  children?: ReactNode;
}

export function MarzipanoViewer({ children }: MarzipanoViewerProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const { controller } = useMarzipano(containerRef);

  return (
    <MarzipanoControllerContext.Provider value={controller}>
      <div className={styles.viewerWrap}>
        <div className={styles.viewerStage}>
          <div
            ref={containerRef}
            className={styles.viewer}
            role="application"
            aria-label="360 panorama viewer"
          />
        </div>
        <TourControls />
      </div>
      {children}
    </MarzipanoControllerContext.Provider>
  );
}
